import seriesColours from '../seriesColours';

const MAX_WIDTH = 820;

const swatchStyle = (colour) => ({
  border: `1px solid rgb(${colour})`,
  backgroundColor: `rgba(${colour}, 0.2)`,
  color: `rgb(${colour})`,
  height: '20px',
  width: '20px',
  minWidth: '20px',
});

const itemStyle = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  marginRight: '20px',
  marginBottom: '10px',
  fontSize: '0.925em',
  listStyle: 'none',
};

const labelStyle = {
  margin: 0,
  padding: 0,
  color: '#666',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '200px',
};

const LegendItem = ({ series, index, label, hidden, onToggle }) => (
  <li className='legend-container-select-box' style={itemStyle} onClick={() => onToggle(series.bucket)}>
    <span
      className={`legend-item ${hidden ? '' : 'legend-selected'}`}
      style={{ ...swatchStyle(seriesColours[index % seriesColours.length]), marginTop: 0 }}
    />
    <p style={labelStyle}>{label}</p>
  </li>
);

const BreakdownLegend = ({ breakdown, labelFor, hiddenBuckets, onToggle }) => {
  if (!breakdown?.length) return null;
  return (
    <ul
      className='d-flex align-items-center mb-4 pl-0'
      style={{ maxWidth: MAX_WIDTH, flexWrap: 'wrap', fontSize: '16px' }}
    >
      {breakdown.map((series, index) => (
        <LegendItem
          key={series.bucket}
          series={series}
          index={index}
          label={labelFor(series.bucket)}
          hidden={hiddenBuckets.includes(series.bucket)}
          onToggle={onToggle}
        />
      ))}
    </ul>
  );
};

export { swatchStyle, itemStyle, labelStyle, MAX_WIDTH };
export default BreakdownLegend;
